import React from "react";
import { getLocalString, localNames } from "utils/localisation.service";
import { useSelector } from 'react-redux';

function renderSwitch(param, locales) {
    switch (param) {
        
        //Υποβολή Αίτησης
        case 'task.name.submit_application':
            return <div className="application-badge grey"><span>{getLocalString(locales, localNames.TASK_NAME_SUBMIT_APPLICATION)}</span></div>; 
        //Αξιολόγηση Αίτησης
        case 'task.name.audit_application':
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_AUDIT_APPLICATION)}</span></div>; 
        //Προσωρινή Απόφαση
        //Υποβολή Ένστασης
        case 'task.name.submit_objection':
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_SUBMIT_OBJECTION)}</span></div>; 
        //Αξιολόγηση ΕΕ
        case 'task.name.ee_evaluation':
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_EE_EVALUATION)}</span></div>;
        //Τελική Απόφαση
        case 'task.name.final_decision':
            return <div className="application-badge blue"><span>{getLocalString(locales, localNames.TASK_NAME_FINAL_DECISION)}</span></div>; 
        //Επιλαχούσα Αίτηση
        case 'task.name.alternate_application':
            return <div className="application-badge blue"><span>{getLocalString(locales, localNames.TASK_NAME_ALTERNATE_APPLICATION)}</span></div>; 
        //Απόρριψη Αίτησης
        case 'task.name.application_rejection':
            return <div className="application-badge red"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_REJECTION)}</span></div>; 
        //Έναρξη Προγράμματος
        // case 'task.name.program_start':
        //     return <div className="application-badge purple"><span>{getLocalString(locales, localNames.TASK_NAME_PROGRAM_START)}</span></div>;
        //Προσωρινή Ένταξη
        case 'task.name.implementation_monitoring':
            return <div className="application-badge purple"><span>{getLocalString(locales, localNames.TASK_NAME_IMPLEMENTATION_MONITORING)}</span></div>;    
        //Αξιολόγηση Εγγράφων
        case 'task.name.document_evaluation':
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_DOCUMENT_EVALUATION)}</span></div>; 
        //Ένσταση Εγγράφων
        case 'task.name.document_objection':
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_DOCUMENT_OBJECTION)}</span></div>; 
        //Αξιολόγηση ΕΕ Εγγράφων
        case 'task.name.ee_document_evaluation':
            return <div className="application-badge orange"><span>{getLocalString(locales, localNames.TASK_NAME_EE_DOCUMENT_EVALUATION)}</span></div>; 
        //Πληρωμή
        // case 'task.name.payment':
        //     return <div className="application-badge green"><span>{getLocalString(locales, localNames.TASK_NAME_PAYMENT)}</span></div>; 
        //Έναρξη Προγράμματος
        case 'task.name.implementation_monitoring_doc_submission':
            return <div className="application-badge green"><span>{getLocalString(locales, localNames.TASK_NAME_IMPLEMENTATION_MONITORING_DOC_SUBMISSION)}</span></div>;
        //Απένταξη Αίτησης
        case 'task.name.application_withdrawal':
            return <div className="application-badge red"><span>{getLocalString(locales, localNames.TASK_NAME_APPLICATION_WITHDRAWAL)}</span></div>;
        //ακύρωση Αίτησης
        case 'task.name.cancelled_task':
            return <div className="application-badge red"><span>{getLocalString(locales, localNames.TASK_NAME_CANCELLED_TASK)}</span></div>; 
        default:
            return null;
    }
}

const StatusTag = (props) => {
    const locales = useSelector(state => state.forms?.localeStrings);
    return renderSwitch(props.status, locales);
}

export default StatusTag;